module.exports = __webpack_public_path__ + "img/ES-M-18.8fe0c2b0.svg";